let url = process.env.API_URL || "http://localhost:4200";
if (window.location.host === "brij.ticketak.com") {
  url = "http://18.136.206.103:3800";
  // NEW
  // url = "http://13.234.176.118:3800";
} else if (
  window.location.host === "dev.brij.tech" ||
  window.location.host === "dev-pos-dual-display.brij.tech"
) {
  url = "http://18.136.206.103:3810";
  // NEW
  // url = "http://13.234.176.118:3810";
} else if (window.location.host === "uat.brij.tech") {
  url = "http://18.136.206.103:3811";
  // NEW
  // url = "http://13.234.176.118:3811";
} else if (window.location.host === "solapur.brij.tech") {
  url = "https://solapur-api.brij.tech"; // url = "http://18.138.243.76:3800";
} else if (window.location.host === "shringar.brij.tech:3951") {
  url = "http://shringar.brij.tech:3950";
} else if (window.location.host === "shringar.brij.tech:3961") {
  url = "http://shringar.brij.tech:3960";
} else if (window.location.host === "shringar.brij.tech:3901") {
  url = "http://shringar.brij.tech:3900";
} else if (window.location.host === "shringar.brij.tech:3502") {
  url = "http://shringar.brij.tech:3501";
} else if (window.location.host === "shringar.brij.tech:3971") {
  url = "http://shringar.brij.tech:3970";
} else if (window.location.host === "brij-gdc-3.brij.tech") {
  url = "https://cinematic-server-gdc-3.brij.tech";
} else if (window.location.host === "brij-imaculix-1.brij.tech") {
  url = "https://cinematic-server-imaculix-1.brij.tech";
} else if (window.location.hostname === "192.168.1.189") {
  url = "http://192.168.1.189:3800";
} else {
  url = process.env.API_URL || "http://localhost:4200";
  // url = "https://cinematic-server-imaculix-1.brij.tech";

  // Testing
  // url = "http://shringar.brij.tech:3950";
  // url = "http://shringar.brij.tech:3950";
  // url = "http://shringar.brij.tech:3950";
  //   url = "http://192.168.1.155:3800";
  // local IPS
  // url = "http://192.168.0.135:3811";
  // url = "http://192.168.1.181:3800";
  // url = "http://159.65.251.47:3900";
  // url = "http://157.230.36.254:3800";
  // Below For Brij Solapur
  // url = "http://18.136.206.103:3800";
  // UatBrijTech
  // url = "http://18.136.206.103:3811";
  // DevBrijTech
  // url = "http://18.136.206.103:3810";

  // url = "http://18.136.206.103:3801";
}
export const BASEURL = url; // url



// WEBPACK FOOTER //
// ./src/config/index.js